/* ---
  Blinis & Schmand — Beilagen zum Kaviar

  <ec-serve-addons>  „Complete the serve" unter dem Kauf-Button (snippets/ec-serve-addons.liquid).
                     Beim Absenden der Kaufbox hängt es items[n][id]/[quantity] an deren
                     Formular und sperrt dafür kurz id/quantity: /cart/add legt dann Kaviar
                     und Beilagen in einem Schritt in den Warenkorb. Das Absenden selbst
                     (AJAX über <product-form>, sonst klassisch) bleibt bei der Sektion — so
                     laufen Seitenleiste, Zähler und Fehlermeldungen wie immer. Der Knopftext
                     zeigt bei gewählten Beilagen die Summe.
  [data-ec-serve-add]  Knopf, der die Positionen aus data-items hinzufügt (Startseite, sections/ec-serve.liquid).

  Alle Produkte sind auch einzeln kaufbar; das Skript sperrt nichts.
--- */

(function () {

  if ( window.EcServe ) return;

  const settings = () => ( window.KROWN && KROWN.settings ) || { routes: {}, locales: {} };

  /* Geldbeträge wie ProductVariants._formatMoney in component-product-form.js */
  function formatMoney(cents) {
    const format = settings().shop_money_format || '€{{amount_with_comma_separator}}';
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const delimit = (precision, thousands = ',', decimal = '.') => {
      const parts = ( cents / 100 ).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + ( parts[1] ? decimal + parts[1] : '' );
    };
    let value = '';
    switch ( match ? match[1] : 'amount' ) {
      case 'amount_no_decimals': value = delimit(0); break;
      case 'amount_with_comma_separator': value = delimit(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(0, ' '); break;
      case 'amount_with_apostrophe_separator': value = delimit(2, "'"); break;
      default: value = delimit(2);
    }
    return match ? format.replace(match[0], value) : value;
  }

  /* Mehrere Positionen auf einmal hinzufügen, danach Warenkorb wie das Theme öffnen */
  function addItems(items) {
    const routes = settings().routes || {};
    return fetch(( routes.cart_add_url || '/cart/add' ) + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items })
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if ( ! ok || data.status ) {
          const message = typeof data.description === 'string' ? data.description : ( data.message || settings().locales.cart_add_error || 'Error' );
          throw new Error(message);
        }
        const overlay = settings().cart_action === 'overlay' && typeof window.refreshCart === 'function' && document.querySelector('[data-js-site-cart-sidebar]');
        if ( overlay ) {
          window.refreshCart();
        } else {
          window.location.href = routes.cart_url || '/cart';
        }
        return data;
      });
  }

  function announce(el, text) {
    if ( ! el ) return;
    el.textContent = '';
    setTimeout(() => { el.textContent = text; }, 60);
  }

  function mainButton(form) {
    return form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
  }

  function buttonLabel(button) {
    return button.querySelector('[data-js-product-add-to-cart-text], [data-lf-atc-text], [data-vod-atc-text]') || button;
  }

  /* ---- „Complete the serve" ---- */

  class EcServeAddons extends HTMLElement {

    connectedCallback() {
      if ( this._ready ) return;
      this.form = document.getElementById(this.dataset.form);
      if ( ! this.form ) return;
      this._ready = true;

      let data = {};
      try {
        data = JSON.parse(this.querySelector('[data-ec-serve-prices]').textContent);
      } catch ( e ) {}
      this.prices = data.prices || {};
      this.statusTemplate = data.status;
      this.statusNone = data.statusNone;
      this.template = this.dataset.template || '{price}';
      this.status = this.querySelector('[data-ec-serve-status]');

      this.setInput = this.querySelector('[data-serve-set]');
      this.singles = Array.from(this.querySelectorAll('[data-serve-single]'));
      this.inputs = Array.from(this.querySelectorAll('.ec-serve__input'));

      // Summe im Kauf-Button: eigene Beschriftung neben der des Themes. Größenwahl,
      // Set-Auswahl und „Ausverkauft" schreiben weiter in ihre Beschriftung; sind Beilagen
      // gewählt, ist nur diese hier sichtbar. So kommen sich die Skripte nie in die Quere.
      this.button = mainButton(this.form);
      this.label = this.button ? buttonLabel(this.button) : null;
      if ( this.label && this.label !== this.button ) {
        this.own = this.button.querySelector('[data-ec-serve-label]');
        if ( ! this.own ) {
          this.own = document.createElement('span');
          this.own.className = this.label.className;
          this.own.setAttribute('data-ec-serve-label', '');
          this.own.style.display = 'none';
          this.label.insertAdjacentElement('afterend', this.own);
        }
      }

      this.inputs.forEach(input => input.addEventListener('change', () => this.onPick(input)));

      this.queue = () => {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this.update(), 0);
      };
      this.form.addEventListener('change', this.queue);
      this.form.addEventListener('input', this.queue);
      this.form.addEventListener('click', this.queue); // +/− der Menge setzen den Wert ohne Event

      if ( this.own ) {
        // Neue Größe, Set oder „Ausverkauft" → Summe bzw. Sichtbarkeit nachziehen
        this.observer = new MutationObserver(this.queue);
        this.observer.observe(this.label, { childList: true, characterData: true, subtree: true });
        this.observer.observe(this.button, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
      }

      this.onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this.onSubmit, true);

      this.syncSingles();
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
      if ( this.observer ) this.observer.disconnect();
      this._ready = false;
    }

    picked() {
      return this.inputs.filter(input => input.checked && ! input.disabled);
    }

    isBlocked() {
      const b = this.button;
      if ( ! b ) return true;
      return b.disabled || b.getAttribute('aria-disabled') === 'true' || b.classList.contains('disabled') || this.form.classList.contains('disabled-cart');
    }

    total(picked) {
      const idInput = this.form.querySelector('[name="id"]');
      const price = idInput ? this.prices[String(idInput.value)] : undefined;
      if ( typeof price !== 'number' ) return null;
      const qtyInput = this.form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      return picked.reduce((sum, input) => sum + ( parseInt(input.dataset.price, 10) || 0 ), price * qty);
    }

    // Set gewählt → Einzelzeilen sperren (sie stecken im Set)
    syncSingles() {
      const setOn = !! ( this.setInput && this.setInput.checked );
      this.singles.forEach(input => {
        if ( setOn ) input.checked = false;
        input.disabled = setOn;
      });
    }

    onPick(input) {
      if ( input === this.setInput ) this.syncSingles();
      this.update();
      const picked = this.picked();
      const total = picked.length ? this.total(picked) : null;
      announce(this.status, picked.length && total !== null ? this.statusTemplate.replace('{price}', formatMoney(total)) : this.statusNone);
    }

    update() {
      const picked = this.picked();
      const names = picked.map(input => input.dataset.title).join(' + ');
      if ( names ) this.form.dataset.ecServeExtra = names;
      else delete this.form.dataset.ecServeExtra;

      // Express-Checkout („Buy with Shop" u. a.) kauft nur die Dose — mit Beilagen ausblenden
      const active = picked.length > 0 && ! this.isBlocked();
      const express = this.form.querySelector('.shopify-payment-button');
      if ( express ) express.style.display = active ? 'none' : '';

      if ( ! this.own ) return;
      const total = active ? this.total(picked) : null;
      if ( total === null ) {
        if ( this.own.style.display !== 'none' ) {
          this.own.style.display = 'none';
          this.label.style.display = '';
        }
        return;
      }
      const text = this.template.replace('{price}', formatMoney(total));
      if ( this.own.textContent !== text ) this.own.textContent = text;
      if ( this.own.style.display === 'none' ) {
        this.own.style.display = '';
        this.label.style.display = 'none';
      }
    }

    onSubmit(e) {
      if ( e.target !== this.form ) return;
      const picked = this.picked();
      if ( ! picked.length || this.isBlocked() ) return;
      const idInput = this.form.querySelector('[name="id"]');
      if ( ! idInput || ! idInput.value || idInput.disabled ) return;

      const added = [];
      const off = [idInput];
      const add = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        this.form.appendChild(input);
        added.push(input);
      };

      const qtyInput = this.form.querySelector('[name="quantity"]');
      let qty = 1;
      if ( qtyInput && ! qtyInput.disabled ) {
        qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        off.push(qtyInput);
      }

      const fields = Array.from(this.form.elements);
      add('items[0][id]', idInput.value);
      add('items[0][quantity]', qty);
      fields.forEach(field => {
        if ( ! field.name || field.disabled || field.type === 'file' ) return;
        if ( ( field.type === 'checkbox' || field.type === 'radio' ) && ! field.checked ) return;
        if ( field.name.indexOf('properties[') === 0 ) {
          add('items[0][properties]' + field.name.slice(10), field.value);
          off.push(field);
        } else if ( field.name === 'selling_plan' && field.value ) {
          add('items[0][selling_plan]', field.value);
          off.push(field);
        }
      });
      picked.forEach((input, index) => {
        add('items[' + ( index + 1 ) + '][id]', input.value);
        add('items[' + ( index + 1 ) + '][quantity]', 1);
      });

      // Die Sektion liest das Formular noch in diesem Ereignis (AJAX) bzw. der Browser
      // direkt danach (klassisch) — danach ist alles wieder wie vorher.
      off.forEach(field => { field.disabled = true; });
      setTimeout(() => {
        added.forEach(input => input.remove());
        off.forEach(field => { field.disabled = false; });
      }, 0);

      if ( window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function' ) {
        Shopify.analytics.publish('serve_addons_added', { variants: picked.map(input => input.value) });
      }
    }

  }

  /* ---- Knöpfe mit festen Positionen (Startseite) ---- */

  document.addEventListener('click', e => {
    const target = e.target && e.target.closest ? e.target : null;
    if ( ! target ) return;

    const addButton = target.closest('[data-ec-serve-add]');
    if ( addButton ) {
      e.preventDefault();
      if ( addButton.classList.contains('working') ) return;
      let items = [];
      try {
        items = JSON.parse(addButton.getAttribute('data-items'));
      } catch ( err ) {
        return;
      }
      const scope = addButton.closest('[data-ec-serve-scope]') || addButton.parentElement;
      const status = scope.querySelector('[data-ec-serve-status]');
      const error = scope.querySelector('[data-ec-serve-error]');
      if ( error ) error.hidden = true;
      addButton.classList.add('working');
      addItems(items)
        .then(() => announce(status, settings().locales.cart_announcement || ''))
        .catch(err => {
          if ( error ) {
            error.textContent = err.message;
            error.hidden = false;
          }
        })
        .finally(() => addButton.classList.remove('working'));
    }
  });

  if ( ! customElements.get('ec-serve-addons') ) customElements.define('ec-serve-addons', EcServeAddons);

  window.EcServe = { addItems, formatMoney };

})();
